import ActionType from "../../Models/ActionType";
import * as types from "./types";
import { Worker, WorkerPosition } from "../../Models/Worker";

export interface WorkerState {
  workers: Worker[];
  workerPositions: WorkerPosition[];
  fetchingWorkers: boolean;
  fetchingWorkerPositions: boolean;
}

const initialState: WorkerState = {
  workers: [],
  workerPositions: [],
  fetchingWorkers: false,
  fetchingWorkerPositions: false,
};

const workers = (
  state: WorkerState = initialState,
  action: ActionType
): WorkerState => {
  switch (action.type) {
    case types.FETCH_WORKERS:
      return {
        ...state,
        fetchingWorkers: true,
      };
    case types.FETCH_WORKERS_SUCCESS:
      return {
        ...state,
        fetchingWorkers: false,
        workers: action.payload as Worker[],
      };
    case types.FETCH_WORKERS_FAILURE:
      return {
        ...state,
        fetchingWorkers: false,
      };

    case types.FETCH_WORKER_POSITIONS:
      return {
        ...state,
        fetchingWorkerPositions: true,
      };
    case types.FETCH_WORKER_POSITIONS_SUCCESS:
      return {
        ...state,
        fetchingWorkerPositions: false,
        workerPositions: action.payload as WorkerPosition[],
      };
    case types.FETCH_WORKER_POSITIONS_FAILURE:
      return {
        ...state,
        fetchingWorkerPositions: false,
      };

    default:
      return state;
  }
};

export default workers;
